/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Image, Modal } from "antd";
import { useHistory } from "react-router";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import {
	AccountDetailsCard,
	ChartView,
	FundsWithdrawal,
	FundWallet,
	Loading,
	NewWithdrawalAcct,
	SplitPane,
	TransactionHistory,
	UpdateBankDetails,
	SetupWallet,
} from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import {
	btnStyle,
	hideScrollbar,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { useQuery } from "react-query";
import right from "../../assets/svg/rightsvg.svg";
import { useMediaQuery } from "react-responsive";
import { fetchAllWallets, useFetchWallet } from "../../redux/actions/wallet";
import { currency } from "../../lib/helpers/currencySymbol";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import Auth from "../../lib/middleware/auth";
import {
	active,
	currencyStyle,
	FundWalletBtn,
	inactive,
	Wrapper,
} from "./component";
import { useTransactionStats } from "../../redux/api/Transaction";
import dayjs from "dayjs";
import CurrencyFormat from "react-currency-format";

const Wallet = (props) => {
	const user = Auth.getUser();
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const history = useHistory();
	const [currencyCode, setCurrencyCode] = useState("NGN");
	const [accountSelected, setAccountSelected] = useState({});
	const [updateAcct, setUpdateAcct] = useState(false);
	const [withdrawalAcct, setWithdrawalAcct] = useState(false);
	const [fundsWithdrawal, setFundsWithdrawal] = useState(false);
	const [walletDt, setWalletDt] = useState([]);
	const [start, setStart] = useState(dayjs().subtract(1, "year").unix());
	const [end, setEnd] = useState(dayjs().unix());
	const [transaction_type, setType] = useState("credit");
	const [frequency, setFrequency] = useState("monthly");
	const [fundWallet, setFundWallet] = useState(false);
	const {
		data: walletData,
		isLoading: loadingWalletData,
		refetch: refectchWalletData,
	} = useQuery("WalletData", fetchAllWallets, {
		refetchOnWindowFocus: false,
	});

	const { data: walletSingle } = useFetchWallet({});

	useEffect(() => {
		if (isEmpty(walletData)) {
			return;
		}
		setWalletDt(walletData.virtual_accounts);
	}, [walletData]);

	const { data: walletStat, isLoading: loadingWalletStat } =
		useTransactionStats({
			start,
			end,
			currencyCode: "NGN",
			transaction_type,
			frequency,
		});

	console
		.log
		// 	"m the wallet data",
		// 	walletData,
		// "i am the wallet stats\n",
		// walletStat
		// 	"I am the single wallet",
		// 	walletSingle
		();

	const WalletSide = () => {
		return (
			<div className="main" css={hideScrollbar}>
				{/* Banner Layout  */}
				<div className="banner">
					{loadingWalletData ? (
						<div tw="flex h-full w-full items-center justify-center">
							<Loading />
						</div>
					) : isEmpty(walletData) ? (
						<>
							{/* Dummy start */}
							<div tw="flex flex-row flex-nowrap items-center justify-center gap-2 md:gap-4">
								<button
									onClick={() => setCurrencyCode("NGN")}
									css={
										currencyCode === "NGN"
											? active
											: inactive
									}>
									<span css={currencyStyle}>₦</span>
									<span tw="capitalize">Naira</span>
								</button>

								{/* <span
									tw="p-2 shadow-md rounded-full opacity-40 flex items-center justify-center"
									style={{
										backgroundColor:
											"rgba(255, 234, 237, 0.4)",
									}}>
									<Image
										preview={false}
										src={right}
										alt=""
										width={8}
										height={8}
									/>
								</span>

								<button
									onClick={() => setCurrencyCode("USD")}
									css={
										currencyCode === "USD"
											? active
											: inactive
									}>
									<span css={currencyStyle}>$</span>
									<span tw="capitalize">Dollar</span>
								</button> */}
							</div>

							<div tw="flex flex-col items-center justify-center">
								<h3 tw="uppercase font-semibold text-sm md:text-base text-white opacity-50 leading-5">
									balance
								</h3>
								<h2 tw="text-white text-3xl font-semibold inline-flex items-center ml-2 hover:cursor-pointer">
									{currencyCode === "NGN"
										? "₦"
										: currencyCode === "USD"
										? "$"
										: ""}{" "}
									0.00
								</h2>
							</div>
							{/* Dummy end  */}
						</>
					) : (
						<>
							<div tw="flex flex-row flex-nowrap items-center justify-center gap-2 md:gap-4">
								{walletData?.wallets?.map((wallet, i) => {
									if (wallet.currency.code !== "NGN") {
										return false;
									}
									const symbol = wallet.currency.symbol
										.split("+")
										.pop();
									return (
										<button
											key={i}
											onClick={() =>
												setCurrencyCode(
													wallet.currency.code
												)
											}
											css={
												currencyCode ===
												wallet.currency.code
													? active
													: inactive
											}>
											<span css={currencyStyle}>
												{currency(symbol)}
											</span>
											<span tw="capitalize">
												{wallet.currency.name}
											</span>
										</button>
									);
								})}

								{walletData?.wallets?.map((wallet, i) => {
									if (wallet.currency.code === "NGN") {
										return false;
									}
									return (
										<Fragment key={i}>
											{/* <span
												tw="p-2 shadow-md rounded-full opacity-40 flex items-center justify-center"
												style={{
													backgroundColor:
														"rgba(255, 234, 237, 0.4)",
												}}>
												<Image
													preview={false}
													src={right}
													alt=""
													width={8}
													height={8}
												/>
											</span> */}

											{/* <button
												onClick={() =>
													// setCurrencyCode(
													// 	wallet.currency.code
													// )
													Toast.fire({
														icon: "error",
														title: "NGN is the only available currency",
													})
												}
												css={
													currencyCode ===
													wallet.currency.code
														? active
														: inactive
												}> */}
											{/* <span css={currencyStyle}>
													{currency(symbol)}
												</span> */}
											{/* <span tw="capitalize">
													{wallet.currency.name}
												</span> */}
											{/* </button> */}
										</Fragment>
									);
								})}
							</div>

							{walletData?.wallets?.map((wallet, i) => {
								if (currencyCode === wallet.currency.code) {
									const symbol = wallet.currency.symbol
										.split("+")
										.pop();
									return (
										<div
											key={i}
											tw="flex flex-col items-center justify-center">
											<h3 tw="uppercase font-semibold text-sm md:text-base text-white opacity-50 leading-5">
												balance
											</h3>
											<h2 tw="text-white text-3xl font-semibold inline-flex items-center ml-2 hover:cursor-pointer">
												<CurrencyFormat
													value={wallet.current_balance?.toFixed(
														2
													)}
													displayType={"text"}
													thousandSeparator={true}
													prefix={currency(symbol)}
												/>
											</h2>
										</div>
									);
								}
								return true;
							})}
						</>
					)}
				</div>

				{(!user.is_wallet_set ||
					!user.is_bvn_set ||
					!user?.is_kyc_verified) && <SetupWallet />}

				<div tw="mt-4 w-full flex flex-row flex-wrap gap-4">
					{!isEmpty(walletDt) && (
						<AccountDetailsCard
							virtualAccounts={walletDt}
							setAccountSelected={setAccountSelected}
							accountSelected={accountSelected}
							setUpdateAcct={setUpdateAcct}
						/>
					)}

					<div tw="w-full flex flex-col flex-wrap gap-2 flex-auto md:flex-1">
						<div>
							<button
								onClick={() => {
									setWithdrawalAcct(true);
								}}
								css={btnStyle}
								tw="bg-appLightPink py-8 md:py-10 flex items-center justify-center text-appTextDark hover:(bg-appGreenGauze)">
								Add withdrawal bank
							</button>
						</div>
						<div>
							<button
								onClick={() => {
									setFundsWithdrawal(true);
								}}
								css={btnStyle}
								tw="w-full  py-8 md:py-10 flex items-center justify-center">
								Withdraw money
							</button>
						</div>
					</div>
				</div>

				<div tw="mt-8">
					<ChartView loading={loadingWalletStat} />
				</div>
			</div>
		);
	};

	return (
		<MainLayout>
			{/* {uploading && <PageLoading />} */}
			<Wrapper css={hideScrollbar}>
				{/* Photo Section */}
				<div tw="w-full inline-flex flex-nowrap justify-between items-center gap-2  mb-4">
					<div
						tw="inline-flex gap-2 items-center hover:cursor-pointer"
						onClick={() => {
							history.goBack();
						}}>
						<ArrowLeftOutlined tw="px-2 py-2 md:(px-3 py-3) bg-gray-100 rounded-full hover:bg-white" />
						<LandingTitle tw="text-lg md:text-2xl font-bold leading-8 m-0">
							My Wallet
						</LandingTitle>
					</div>
					<FundWalletBtn onClick={() => setFundWallet(true)}>
						Fund Wallet
					</FundWalletBtn>
				</div>

				<SplitPane
					wrapDirection={"column"}
					rightHeightAdjust={"12rem"}
					leftHeightAdjust={"10rem"}
					left={<WalletSide />}
					right={<TransactionHistory />}
				/>

				<Modal
					footer=""
					visible={updateAcct}
					centered
					onCancel={() => setUpdateAcct(false)}
					maskClosable={false}>
					<UpdateBankDetails
						account={accountSelected}
						goBack={() => setUpdateAcct(false)}
						refetch={refectchWalletData}
					/>
				</Modal>
				<Modal
					footer=""
					visible={withdrawalAcct}
					centered
					onCancel={() => setWithdrawalAcct(false)}
					maskClosable={false}>
					<NewWithdrawalAcct
						goBack={() => setWithdrawalAcct(false)}
					/>
				</Modal>
				<Modal
					footer=""
					visible={fundsWithdrawal}
					centered
					onCancel={() => setFundsWithdrawal(false)}
					maskClosable={false}>
					<FundsWithdrawal goBack={() => setFundsWithdrawal(false)} />
				</Modal>
				<Modal
					footer=""
					visible={fundWallet}
					centered
					onCancel={() => setFundWallet(false)}
					maskClosable={false}>
					<FundWallet goBack={() => setFundWallet(false)} />
				</Modal>
			</Wrapper>
		</MainLayout>
	);
};

export default Wallet;
